
'use strict';

define('component!LoginProviderComponent',['require','react'],function (require) {
  'use strict';

  var React = require('react');

  var LoginProviderComponent = function LoginProviderComponent(_ref) {
    var translations = _ref.translations;
    var providers = _ref.providers;
    var onProviderClick = _ref.onProviderClick;

    return React.createElement(
      'div',
      { className: 'login-provider-component' },
      React.createElement(
        'h2',
        { className: 'login-provider-component__header' },
        translations.provider_sign_in
      ),
      Object.keys(providers).map(function (provider, i) {
        return React.createElement(
          'a',
          { className: 'login-provider-component__provider', key: 'key_provider_' + i, 'data-provider': provider, onClick: onProviderClick.bind(null, provider) },
          React.createElement('span', { className: 'login-provider-component__provider__icon ' + providers[provider].icon }),
          React.createElement(
            'span',
            { className: 'login-provider-component__provider__name' },
            providers[provider].humanizedName
          )
        );
      })
    );
  };

  return LoginProviderComponent;
});
